import { ContactFragment } from 'src/graphql/generated/graphql'

const isFullContact = (contact: ContactFragment) => {
  return [
    'firstName',
    'lastName',
    'address1',
    'city',
    'state',
    'postalCode',
  ].every(key => contact.hasOwnProperty(key))
}

export default isFullContact
